module.exports = ".login {\n  height: 100%;\n  width: 100%; }\n\n.header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100px;\n  width: 100%; }\n\n.sidebar {\n  position: absolute;\n  top: 100px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 91px;\n  height: calc(100% - 100px); }\n\n.content {\n  height: calc(100% - 100px);\n  width: calc(100% - 91px);\n  position: absolute;\n  left: 91px;\n  top: 100px;\n  overflow: hidden;\n  background-color: #F1F1F1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main